import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './auth.module.scss'

const Footer: FunctionComponent = () => {
    const { t } = useTranslation()

    return (
        <div className={styles.Footer}>
            <a
                href='https://www.cald.fr/conditions-generales-dutilisation/'
                rel='noreferrer'
                target='_blank'
                className={styles.Link}
            >
                {t('termsAndConditions')}
            </a>
            {' | '}
            <a
                href='https://www.cald.fr/politique-de-confidentialite/'
                rel='noreferrer'
                target='_blank'
                className={styles.Link}
            >
                {t('privacyPolicy')}
            </a>
        </div>
    )
}

export default Footer
